module.exports = __webpack_public_path__ + "media/tenant-placement-hero-image-desktop.18663ec2.svg";